
  var aui = window['aui'] = window['aui'] || {};
  // This file was automatically generated from template3.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace aui.banner.
 */

if (typeof aui == 'undefined') { var aui = {}; }
if (typeof aui.banner == 'undefined') { aui.banner = {}; }


aui.banner.banner = function(opt_data, opt_ignored) {
  var output = '';
  var theType__soy3 = opt_data.type != null ? opt_data.type : 'error';
  output += '<div' + ((opt_data.id) ? ' id="' + soy.$$escapeHtml(opt_data.id) + '"' : '') + ' class="aui-banner aui-banner-' + soy.$$escapeHtml(theType__soy3) + aui.renderExtraClasses(opt_data) + '" role="alert"' + aui.renderExtraAttributes(opt_data) + '><div class="aui-banner-row">' + ((theType__soy3 == 'warning') ? aui.icons.icon({icon: 'warning', useIconFont: true, size: 'small', accessibilityText: AJS.I18n.getText('aui.messagecomponent.warning.label')}) : (theType__soy3 == 'error') ? aui.icons.icon({icon: 'error', useIconFont: true, size: 'small', accessibilityText: AJS.I18n.getText('aui.messagecomponent.error.label')}) : '') + '<div class="aui-banner-content">' + soy.$$filterNoAutoescape(opt_data.content) + '</div></div></div>';
  return output;
};
if (goog.DEBUG) {
  aui.banner.banner.soyTemplateName = 'aui.banner.banner';
}

        module.exports = aui.banner;